import { useLocation, useNavigate } from "react-router-dom";
import { ButtonV4 } from "../atoms/button";
import SearchBar from "../atoms/searchBar";
import { MediaTypeFilter } from "../atoms/mediaTypeFilter";
import { MobileFilterTags } from "../atoms/mobileFilterTags";
import { getAuthFromLocal } from "../../utils/storage";
import { useEffect, useState } from "react";
import { authDetails, loginHandler } from "../../api/auth/authActions";
import { useGetUserQuery } from "../../api/users/users";
import Menu from "../../assets/Content.png";
import Close from "../../assets/Close.png";
import { useDispatch } from "react-redux";
import "./header.css";

interface ItemSchema {
  _id: string;
  title: string;
}

interface props {
  setRegex: Function;
  setKeyword: Function;
  setPageNo: Function;
  regex: string;
  setShowMenu: Function;
  showMenu: boolean;
  onRemoveFilter?: (filterType: string, item: ItemSchema) => void;
}

export function Header({ setRegex, setKeyword, setPageNo, regex, setShowMenu, showMenu, onRemoveFilter }: props) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<any>();
  const { pathname } = location;

  function navigation() {
    navigate("/admin");
  }
  function navigation2() {
    navigate("/");
  }

  let data: authDetails = getAuthFromLocal();

  const { refetch, data: userData } = useGetUserQuery({});

  useEffect(() => {
    // keep original logic
    refetch();
    if (userData) {
      let authDetails = {
        accessToken: userData.data.authToken,
        userId: userData.data._id,
        email: userData.data.email,
        fullName: userData.data.fullName,
        active: userData.data.active,
        isEmailVerified: userData.data.isEmailVerified,
        registrationStatus: userData.data.registrationStatus,
        roles: userData.data.roles[0],
      };
      dispatch(loginHandler(authDetails));
    }
    !data && navigate("/");
  }, [pathname]);

  const handleClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "Engage_Tap_Logo",
        category: "User Interaction",
        action: "Button Click",
        label: "Logo Button",
      });
    }
    window.location.reload();
  };



  return (
    <>
      {/* Top header row: Logo and hamburger menu */}
      <div className="top-main sticky top-0 w-full bg-white flex flex-col lg:flex-row justify-between z-50 items-center">
        {/* Logo */}
        <div className="col-lg-3 col-md-3 flex items-center justify-between w-full lg:w-auto">
          <a
            href="/home"
            className="cursor-pointer flex items-center"
            onClick={(e) => {
              e.preventDefault();
              handleClick();
            }}
          >
            <img
              src="/img/logo.svg"
              alt="logo"
              className="h-auto w-[80%] min-w-[8rem] object-contain cursor-pointer"
              onClick={() => handleClick()}
              role="presentation"
            />
          </a>

          {/* Hamburger menu for mobile */}
          <div className="lg:hidden flex items-center">
            <button
              aria-label={showMenu ? "Close menu" : "Open menu"}
              aria-expanded={showMenu}
              onClick={() => setShowMenu((s: any) => !s)}
              className="focus:outline-none cursor-pointer border-none"
            >
              {showMenu ? (
                <img
                  src={Close}
                  alt="Close"
                  className="w-5 h-5 mr-[4px]"
                />
              ) : (
                <img
                  src={Menu}
                  alt="Menu"
                  className="w-8 h-8"
                />
              )}
            </button>
          </div>
        </div>
        <div className="col-lg-9 col-md-9  main-row flex flex-col lg:flex-row items-center w-full lg:flex-1">
          {/* Unified Media Filter and Search Bar */}
          <div className="flex items-center w-full lg:flex-1">
            <div className="unified-search-container w-full">
              <MediaTypeFilter className="integrated-filter" />
              <div className="search-separator"></div>
              <div className="integrated-search-wrapper flex-1 min-w-0 lg:min-w-[720px] xl:min-w-[900px]">
                <SearchBar
                  setRegex={setRegex}
                  setKeyword={setKeyword}
                  setPageNo={setPageNo}
                  regex={regex}
                />
              </div>
            </div>
          </div>
          {/* Admin Dashboard Button */}
          {userData?.data?.roles[0] !== "user" && (
            <ButtonV4
              color="blue"
              setActive={navigation}
              className="header-btn"
            >
              <img
                src="/img/Vector.svg"
                alt="Admin Dashboard"
                className="pointer-events-none"
              />
            </ButtonV4>
          )}
        </div>
      </div>



      {/* Mobile Filter Tags - only show on mobile and when filters are applied */}
      <div className="lg:hidden">
        {onRemoveFilter && (
          <MobileFilterTags onRemoveFilter={onRemoveFilter} />
        )}
      </div>
    </>
  );
}

export function AdminHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<any>();
  const { pathname } = location;

  function navigation() {
    navigate("/home");
  }

  const { refetch, data: userData } = useGetUserQuery({});

  let data: authDetails = getAuthFromLocal();

  useEffect(() => {
    refetch();
    if (userData) {
      let authDetails = {
        accessToken: userData.data.authToken,
        userId: userData.data._id,
        email: userData.data.email,
        fullName: userData.data.fullName,
        active: userData.data.active,
        isEmailVerified: userData.data.isEmailVerified,
        registrationStatus: userData.data.registrationStatus,
        roles: userData.data.roles[0],
      };
      dispatch(loginHandler(authDetails));
    }

    !data && navigate("/");

    if (data?.roles) {
      data?.roles === "user" && navigate("/home");
    }
  }, [pathname]);

  const handleClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "Engage_Tap_Logo",
        category: "User Interaction",
        action: "Button Click",
        label: "Logo Button",
      });
    }
    // Refresh the current page on logo click
    window.location.reload();
  };  

  return (
    <div className="sticky top-0 w-full lg:h-[10vh] h-[20vh] overflow-hidden bg-gray-900 px-[2vw] py-[2vh] flex flex-col lg:flex-row justify-between z-50 items-center">
      <a
            href="/admin"
            className="cursor-pointer flex items-center"
            onClick={(e) => {
              e.preventDefault();
              handleClick();
            }}
          >
      <img
        src="/img/logoDark.svg"
        alt="logo"
        className="h-auto min-h-[50px] w-auto object-contain cursor-pointer max-w-[220px] sm:max-w-[180px]"
        onClick={() => handleClick()}
      />
      </a>
      <div className="flex w-max gap-2">
        <ButtonV4 color="blue" setActive={navigation}>
          User Dashboard
        </ButtonV4>
      </div>
    </div>
  );
}